import Authorization from "../../generics/authorization";
import TabNavigation from "../../common/TabNavigation";
import { getCookie } from "../../serviceWorker";
import SubmenuHeaderView from "../insights/SubmenuHeaderView";
import { MFE_COMPONENT_IDS } from "../../utils/enums";

/**
 * Layout constants for grid positioning.
 */
const LAYOUT_CONSTANTS = {
  X_VALUE: 0,
  W_VALUE: 12,
  HEADER_HEIGHT: 4,
  TAB_HEIGHT: 4,
};

const UI_CONVERGENCE_COOKIE = "cl-analytics";

const createConvergenceHeader = () => ({
  filterDashlets: [
    {
      component: SubmenuHeaderView,
      name: "predictive-header",
      layout: {
        x: LAYOUT_CONSTANTS.X_VALUE,
        y: 0,
        w: LAYOUT_CONSTANTS.W_VALUE,
        h: LAYOUT_CONSTANTS.HEADER_HEIGHT
      }
    }
  ]
});

const createLegacyHeader = () => ({
  filterDashlets: [
    {
      component: TabNavigation,
      name: "tab-nav",
      layout: {
        x: LAYOUT_CONSTANTS.X_VALUE,
        y: 0,
        w: LAYOUT_CONSTANTS.W_VALUE,
        h: LAYOUT_CONSTANTS.TAB_HEIGHT
      }
    }
  ]
});

// Main configuration
const getPageHeader = () => {
  const isUIConvergence = getCookie(UI_CONVERGENCE_COOKIE);
  return isUIConvergence ? createConvergenceHeader() : createLegacyHeader();
};

const createPageProps = () => ({
  ...getPageHeader(),
  componentId: MFE_COMPONENT_IDS.OPTIMIZATION,
  dashlets: []
});

/**
 * OptimizationPage
 * Renders the Authorization wrapper for the Optimization MFE.
 * The shell keeps the existing header while the MFE owns the time filter and
 * Optimization content.
 * The shell keeps the existing header while the MFE owns the time filter and
 * Optimization content.
 */
const OptimizationPage = () => <Authorization pageProps={createPageProps()} />;

export default OptimizationPage;
